<template>
	<div class="document-h5">
    <NavBar :className="'auto-width'" :model="'h5'"/>
    <router-view class="h5-main"/>
  </div>
</template>
<script type="text/javascript">
import NavBar from './components/NavBar'
export default {
	name: 'H5',
	components: {
    NavBar,
  },
	data () {
		return {
			
		}
	},
	created () {
    this.$root.model = 'h5'
	},
	mounted () {		
  		
	}
}
</script>
<style lang='scss' scoped>
@import '@/css/base.scss';
@import '@/css/H5.scss';
.document-h5 {
  margin: 0;
  padding-top: 90px;
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>


// WEBPACK FOOTER //
// src/views/H5/index.vue